import React, { createContext, useContext, useEffect, useReducer } from "react";

import CartReducer, {
  CartProductType,
  sumItems,
} from "../reducers/CartReducer";
import { CartActionType } from "../utils/actions";

const getLocalStorage = () => {
  // localStorage.clear();
  const cart = localStorage.getItem("cart");
  if (cart) {
    return JSON.parse(localStorage.getItem("cart") || "");
  } else {
    return [];
  }
};

const CartContext = createContext({
  cartItems: [] as CartProductType[],
  itemCount: 0,
  totalAmount: 0,
  addToCart: (
    id: number,
    brand: string,
    name: string,
    price: number,
    quantity: number,
    category?: string,
    imageUrl?: string
  ) => {},
  removeItem: (
    id: number,
    brand: string,
    name: string,
    price: number,
    quantity: number,
    category?: string,
    imageUrl?: string
  ) => {},
});

const initialState = {
  cartItems: getLocalStorage(),
  itemCount: 0,
  totalAmount: 0,
};

export const CartProvider = (props: any) => {
  const { children } = props;
  const [state, dispatch] = useReducer(CartReducer, initialState);

  // add to cart
  const addToCart = (
    id: number,
    brand: string,
    name: string,
    price: number,
    quantity: number,
    category?: string,
    imageUrl?: string
  ) => {
    dispatch({
      type: CartActionType.AddItem,
      payload: { id, brand, name, price, quantity, category, imageUrl },
    });
  };
  // remove item from cart
  const removeItem = (
    id: number,
    brand: string,
    name: string,
    price: number,
    quantity: number,
    category?: string,
    imageUrl?: string
  ) => {
    dispatch({
      type: CartActionType.RemoveItem,
      payload: { id, brand, name, price, quantity, category, imageUrl },
    });
  };

  useEffect(() => {
    dispatch({ type: CartActionType.CountTotal });
    localStorage.setItem("cart", JSON.stringify(state.cartItems));
  }, [state.cartItems]);

  const contextValues = {
    ...state,
    ...sumItems(state.cartItems),
    addToCart,
    removeItem,
  };

  return (
    <CartContext.Provider value={contextValues}>
      {children}
    </CartContext.Provider>
  );
};
// make sure use
export const useCartContext = () => {
  return useContext(CartContext);
};
